// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NJgt","textarea":"styles_textarea__BZzOs"};